
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  --cover-size:40px;
  --cover-fade:30%;
  --cover-color:#fff;
  --shadow-size:12px;
  --shadow-intensity:40%;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-family: Open Sans, Helvetica, Arial, sans-serif;
  font-weight: var(--fw-normal);
  color: var(--blue-responsible-darken-1);
}

th {
  background-color: var(--cyan-near-main);
  text-align: left;
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
  font-weight: var(--fw-semibold);
  color: var(--neutral-white);
}

th a {
  display: flex;
}

th a {
  align-items: center;
}

th a {
  color: var(--outline-white);
}

th a {
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

th a:hover {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}

th a .tablesort {
  margin-left: 1.25rem;
}

th a .tablesort {
  height: 1.25rem;
}

th a .tablesort {
  width: 1.25rem;
}

th a .tablesort {
  background-repeat: no-repeat;
}

th a .tablesort{
      background:url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 19V5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 12L12 5L19 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
      background-position:center;
    }

th a .tablesort.tablesort--desc{
        transform:rotate(180deg);
      }

th a .tablesort .visually-hidden {
  visibility: hidden;
}

tbody tr {
  border-bottom-width: 1px;
  border-top-width: 0px;
  border-right-width: 0px;
  border-left-width: 0px;
  border-style: solid;
  border-color: var(--gray-professional-lighten-3);
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

tbody tr:nth-child(odd) {
  background-color: var(--neutral-white);
}

tbody tr:nth-child(even) {
  background-color: var(--neutral-grayLight);
}

tbody td a {
  font-weight: var(--fw-semibold);
}

tbody td a {
  color: var(--blue-responsible-main);
}

tbody td a {
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

tbody td a:hover {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}

.table-wrapper {
  overflow-x: auto;
  background:linear-gradient(
      to right,
      var(--cover-color) var(--cover-fade),
      rgba(255, 255, 255, 0)
    ), linear-gradient(
        to right,
        rgba(255, 255, 255, 0),
        var(--cover-color) calc(100% - var(--cover-fade))
      ) 100% 0, radial-gradient(
        farthest-side at 0 50%,
        rgba(0, 0, 0, var(--shadow-intensity)),
        rgba(0, 0, 0, 0)
      ), radial-gradient(
        farthest-side at 100% 50%,
        rgba(0, 0, 0, var(--shadow-intensity)),
        rgba(0, 0, 0, 0)
      ) 100% 0;
  background-repeat:no-repeat;
  background-size:var(--cover-size) 100%, var(--cover-size) 100%,
    var(--shadow-size) 100%, var(--shadow-size) 100%;
  background-attachment:local, local, scroll, scroll;
  overflow:auto;
  -ms-overflow-style:none;
  scrollbar-width:none;
}

.table-wrapper--sticky table {
  min-width: 1440px;
}

.table-wrapper--sticky th:first-child, .table-wrapper--sticky td:first-child {
  position: sticky;
}

.table-wrapper--sticky th:first-child, .table-wrapper--sticky td:first-child {
  left: 0px;
}

@media screen and (max-width: 1440px){
      .table-wrapper--sticky th:first-child::after, .table-wrapper--sticky td:first-child::after{
        content:'';
        position:absolute;
        top:0;
        right:-1px;
        width:1px;
        height:100%;
        background-color:var(--cyan-near-main);
      }
    }

.table-wrapper--sticky tbody tr:nth-child(odd) th:first-child, .table-wrapper--sticky tbody tr:nth-child(odd) td:first-child {
  background-color: var(--neutral-white);
}

.table-wrapper--sticky tbody tr:nth-child(even) th:first-child, .table-wrapper--sticky tbody tr:nth-child(even) td:first-child {
  background-color: var(--neutral-grayLight);
}

.table-wrapper--sticky thead th:first-child::after{
      background-color:var(--cyan-near-darken-2);
    }

:host {
  display: block;
}

.uppercase{
  text-transform:uppercase;
}

:host([capital-style='uppercase']) {
  letter-spacing: 0.1em;
  text-transform:uppercase;
}

:host([capital-style='capitalize']) {
  text-transform: capitalize;
}

:host([capital-style='lowercase']) {
  text-transform: lowercase;
}

:host([capital-style='none']) {
  text-transform: none;
}

:host([capital-style='full-width']){
  text-transform:full-width;
}

:host([capital-style='full-size-kana']){
  text-transform:full-size-kana;
}

:host span, :host p, :host h1, :host h2, :host h3, :host h4, :host h5, :host h6 {
  font-family: Open Sans, Helvetica, Arial, sans-serif;
}

:host([margin-size='0px']) span, :host([margin-size='0px']) p, :host([margin-size='0px']) h1, :host([margin-size='0px']) h2, :host([margin-size='0px']) h3, :host([margin-size='0px']) h4, :host([margin-size='0px']) h5, :host([margin-size='0px']) h6 {
  margin: 0px;
}

:host([margin-size='4px']) span, :host([margin-size='4px']) p, :host([margin-size='4px']) h1, :host([margin-size='4px']) h2, :host([margin-size='4px']) h3, :host([margin-size='4px']) h4, :host([margin-size='4px']) h5, :host([margin-size='4px']) h6 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

:host([margin-size='8px']) span, :host([margin-size='8px']) p, :host([margin-size='8px']) h1, :host([margin-size='8px']) h2, :host([margin-size='8px']) h3, :host([margin-size='8px']) h4, :host([margin-size='8px']) h5, :host([margin-size='8px']) h6 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

:host([margin-size='12px']) span, :host([margin-size='12px']) p, :host([margin-size='12px']) h1, :host([margin-size='12px']) h2, :host([margin-size='12px']) h3, :host([margin-size='12px']) h4, :host([margin-size='12px']) h5, :host([margin-size='12px']) h6 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}

:host([margin-size='20px']) span, :host([margin-size='20px']) p, :host([margin-size='20px']) h1, :host([margin-size='20px']) h2, :host([margin-size='20px']) h3, :host([margin-size='20px']) h4, :host([margin-size='20px']) h5, :host([margin-size='20px']) h6 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}

:host([margin-size='24px']) span, :host([margin-size='24px']) p, :host([margin-size='24px']) h1, :host([margin-size='24px']) h2, :host([margin-size='24px']) h3, :host([margin-size='24px']) h4, :host([margin-size='24px']) h5, :host([margin-size='24px']) h6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.style-override--search-results-eyebrow{
  -webkit-margin-before:20px;
          margin-block-start:20px;
  -webkit-margin-after:0px;
          margin-block-end:0px;
}

.style-override--search-results-title{
  -webkit-margin-before:0px;
          margin-block-start:0px;
}

.style-override--bg-black {
  color: var(--neutral-white);
}

.idb-text--base {
  font-size: var(--fs-base) !important;
  line-height: var(--lh-base) !important;
}

.idb-text--xs {
  font-size: var(--fs-xs) !important;
  line-height: var(--lh-xs) !important;
}

.idb-text--sm {
  font-size: var(--fs-sm) !important;
  line-height: var(--lh-sm) !important;
}

.idb-text--lg {
  font-size: var(--fs-lg) !important;
  line-height: var(--lh-lg) !important;
}

.idb-text--lg.mobile {
  font-size: var(--fs-lg) !important;
  line-height: var(--lh-lg) !important;
}

.idb-text--xl {
  margin-bottom: 0px !important;
  font-size: var(--fs-xl) !important;
  line-height: var(--lh-xl) !important;
}

.idb-text--xl.mobile {
  margin-bottom: 0px !important;
  font-size: var(--fs-xl) !important;
  line-height: var(--lh-xl) !important;
}

.idb-text--2xl {
  font-size: var(--fs-2xl) !important;
  line-height: var(--lh-2xl) !important;
}

.idb-text--2xl.mobile {
  font-size: var(--fs-xl) !important;
  line-height: var(--lh-xl) !important;
}

.idb-text--3xl {
  font-size: var(--fs-3xl) !important;
  line-height: var(--lh-3xl) !important;
}

.idb-text--3xl.mobile {
  font-size: var(--fs-2xl) !important;
  line-height: var(--lh-2xl) !important;
}

.idb-text--4xl {
  font-size: var(--fs-4xl) !important;
  line-height: var(--lh-4xl) !important;
}

.idb-text--4xl.mobile {
  font-size: var(--fs-3xl) !important;
  line-height: var(--lh-3xl) !important;
}

.idb-text--5xl {
  font-size: var(--fs-5xl) !important;
  line-height: var(--lh-5xl) !important;
}

.idb-text--5xl.mobile {
  font-size: var(--fs-2xl) !important;
  line-height: var(--lh-2xl) !important;
}

.idb-text--6xl {
  font-size: var(--fs-6xl) !important;
  line-height: var(--lh-6xl) !important;
}

.idb-text--6xl.mobile {
  font-size: var(--fs-3xl) !important;
  line-height: var(--lh-3xl) !important;
}

.idb-text--7xl {
  font-size: var(--fs-7xl) !important;
  line-height: var(--lh-7xl) !important;
}

.idb-text--7xl.mobile {
  font-size: var(--fs-4xl) !important;
  line-height: var(--lh-4xl) !important;
}

.idb-text--8xl {
  font-size: var(--fs-8xl) !important;
  line-height: var(--lh-8xl) !important;
}

.idb-text--8xl.mobile {
  font-size: var(--fs-5xl) !important;
  line-height: var(--lh-5xl) !important;
}

.idb-text--9xl {
  font-size: var(--fs-9xl) !important;
  line-height: var(--lh-9lx) !important;
}

.idb-text--9xl.mobile {
  font-size: var(--fs-6xl) !important;
  line-height: var(--lh-6xl) !important;
}

.idb-font--thin {
  font-weight: var(--fw-extralight);
}

.idb-font--extralight {
  font-weight: var(--fw-thin);
}

.idb-font--light {
  font-weight: var(--fw-light);
}

.idb-font--normal {
  font-weight: var(--fw-normal);
}

.idb-font--medium {
  font-weight: var(--fw-medium);
}

.idb-font--semibold {
  font-weight: var(--fw-semibold);
}

.idb-font--bold {
  font-weight: var(--fw-bold);
}

.idb-font--extrabold {
  font-weight: var(--fw-extrabold);
}

.idb-font--black {
  font-weight: var(--fw-black);
}

.style-override--card-title {
  margin: 0px;
  margin-bottom: 1rem;
  color: var(--blue-responsible-main);
  font-size:1.125rem;
}

.style-override--image-banner-cta{
  font-size:3.75rem !important;
  line-height:1 !important;
}

:host{
  display:block;
}

:host p, .ck-content p, .cke_editable p, .styled-text p {
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
}

:host p, .ck-content p, .cke_editable p, .styled-text p{
    margin-bottom:1em;
  }

:host p.card-text, .ck-content p.card-text, .cke_editable p.card-text, .styled-text p.card-text {
  font-size: var(--fs-base);
  line-height: var(--lh-base);
}

:host ul, .ck-content ul, .cke_editable ul, .styled-text ul {
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
}

:host ul, .ck-content ul, .cke_editable ul, .styled-text ul{
    list-style-type:disc;
    list-style-position:inside;
  }

:host ol, .ck-content ol, .cke_editable ol, .styled-text ol {
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
}

:host ol, .ck-content ol, .cke_editable ol, .styled-text ol{
    list-style-type:decimal;
    list-style-position:inside;
  }

:host li, .ck-content li, .cke_editable li, .styled-text li{
    padding-left:1em;
    margin-top:0.5em;
    margin-bottom:0.5em;
  }

:host hr, .ck-content hr, .cke_editable hr, .styled-text hr{
    border-color:var(--brand-primary);
  }

:host hr, .ck-content hr, .cke_editable hr, .styled-text hr{
    margin-top:2em;
    margin-bottom:2em;
  }

:host blockquote, .ck-content blockquote, .cke_editable blockquote, .styled-text blockquote {
  position: relative;
}

:host blockquote, .ck-content blockquote, .cke_editable blockquote, .styled-text blockquote {
  background-color: var(--blue-responsible-lighten-5);
}

:host blockquote, .ck-content blockquote, .cke_editable blockquote, .styled-text blockquote{
    padding-top:2.5rem;
    padding-left:3rem;
    padding-bottom:1.5rem;
    padding-right:1.25rem;
    margin-top:1em;
    margin-bottom:1em;
    font-size:var(--fs-lg);
    border-radius:8px;
  }

:host blockquote::before, .ck-content blockquote::before, .cke_editable blockquote::before, .styled-text blockquote::before{
      content:'"';
    }

:host blockquote::before, .ck-content blockquote::before, .cke_editable blockquote::before, .styled-text blockquote::before {
  margin-right: 1rem;
}

:host blockquote::before, .ck-content blockquote::before, .cke_editable blockquote::before, .styled-text blockquote::before {
  display: inline-block;
}

:host blockquote::before, .ck-content blockquote::before, .cke_editable blockquote::before, .styled-text blockquote::before {
  font-family: Open Sans, Helvetica, Arial, sans-serif;
}

:host blockquote::before, .ck-content blockquote::before, .cke_editable blockquote::before, .styled-text blockquote::before {
  font-size: var(--fs-4xl);
  line-height: var(--lh-4xl);
}

:host blockquote::before, .ck-content blockquote::before, .cke_editable blockquote::before, .styled-text blockquote::before {
  font-weight: var(--fw-semibold);
}

:host blockquote::before, .ck-content blockquote::before, .cke_editable blockquote::before, .styled-text blockquote::before {
  font-style: italic;
}

:host blockquote::before, .ck-content blockquote::before, .cke_editable blockquote::before, .styled-text blockquote::before {
  color: var(--blue-responsible-lighten-2);
}

:host blockquote::before, .ck-content blockquote::before, .cke_editable blockquote::before, .styled-text blockquote::before {
  position: absolute;
}

:host blockquote::before, .ck-content blockquote::before, .cke_editable blockquote::before, .styled-text blockquote::before {
  top: 1rem;
}

:host blockquote::before, .ck-content blockquote::before, .cke_editable blockquote::before, .styled-text blockquote::before {
  left: 1rem;
}

:host blockquote::before, .ck-content blockquote::before, .cke_editable blockquote::before, .styled-text blockquote::before{
      transform:translateY(17px);
    }

:host a, :host a:hover, .ck-content a, .ck-content a:hover, .cke_editable a, .cke_editable a:hover, .styled-text a, .styled-text a:hover {
  font-weight: var(--fw-semibold);
}

:host a, :host a:hover, .ck-content a, .ck-content a:hover, .cke_editable a, .cke_editable a:hover, .styled-text a, .styled-text a:hover {
  color: var(--idblab-magenta-main);
}

:host a, :host a:hover, .ck-content a, .ck-content a:hover, .cke_editable a, .cke_editable a:hover, .styled-text a, .styled-text a:hover {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}

:host h1, :host h2, :host h3, :host h4, :host h5, :host h6, .ck-content h1, .ck-content h2, .ck-content h3, .ck-content h4, .ck-content h5, .ck-content h6, .cke_editable h1, .cke_editable h2, .cke_editable h3, .cke_editable h4, .cke_editable h5, .cke_editable h6, .styled-text h1, .styled-text h2, .styled-text h3, .styled-text h4, .styled-text h5, .styled-text h6 {
  font-weight: var(--fw-semibold);
}

:host h1, :host h2, :host h3, :host h4, :host h5, :host h6, .ck-content h1, .ck-content h2, .ck-content h3, .ck-content h4, .ck-content h5, .ck-content h6, .cke_editable h1, .cke_editable h2, .cke_editable h3, .cke_editable h4, .cke_editable h5, .cke_editable h6, .styled-text h1, .styled-text h2, .styled-text h3, .styled-text h4, .styled-text h5, .styled-text h6 {
  color: var(--idblab-magenta-main);
}

:host .text-align-center, .ck-content .text-align-center, .cke_editable .text-align-center, .styled-text .text-align-center{
    text-align:center;
  }

:host .text-align-right, .ck-content .text-align-right, .cke_editable .text-align-right, .styled-text .text-align-right{
    text-align:right;
  }

:host .text-align-left, .ck-content .text-align-left, .cke_editable .text-align-left, .styled-text .text-align-left{
    text-align:left;
  }

:host .align-left, .ck-content .align-left, .cke_editable .align-left, .styled-text .align-left{
    float:left;
  }

:host .align-right, .ck-content .align-right, .cke_editable .align-right, .styled-text .align-right{
    float:right;
  }

:host .align-center, .ck-content .align-center, .cke_editable .align-center, .styled-text .align-center{
    display:block;
    margin-right:auto;
    margin-left:auto;
  }

:host .align-center img, .ck-content .align-center img, .cke_editable .align-center img, .styled-text .align-center img{
      margin:0 auto;
    }

:host .idb-button-primary, :host .idb-button-secondary, .ck-content .idb-button-primary, .ck-content .idb-button-secondary, .cke_editable .idb-button-primary, .cke_editable .idb-button-secondary, .styled-text .idb-button-primary, .styled-text .idb-button-secondary {
  display: inline-block;
}

:host .idb-button-primary, :host .idb-button-secondary, .ck-content .idb-button-primary, .ck-content .idb-button-secondary, .cke_editable .idb-button-primary, .cke_editable .idb-button-secondary, .styled-text .idb-button-primary, .styled-text .idb-button-secondary {
  cursor: pointer;
}

:host .idb-button-primary, :host .idb-button-secondary, .ck-content .idb-button-primary, .ck-content .idb-button-secondary, .cke_editable .idb-button-primary, .cke_editable .idb-button-secondary, .styled-text .idb-button-primary, .styled-text .idb-button-secondary {
  border-radius: 0.5rem;
}

:host .idb-button-primary, :host .idb-button-secondary, .ck-content .idb-button-primary, .ck-content .idb-button-secondary, .cke_editable .idb-button-primary, .cke_editable .idb-button-secondary, .styled-text .idb-button-primary, .styled-text .idb-button-secondary {
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

:host .idb-button-primary, :host .idb-button-secondary, .ck-content .idb-button-primary, .ck-content .idb-button-secondary, .cke_editable .idb-button-primary, .cke_editable .idb-button-secondary, .styled-text .idb-button-primary, .styled-text .idb-button-secondary {
  transition-duration: 300ms;
}

:host .idb-button-primary, :host .idb-button-secondary, .ck-content .idb-button-primary, .ck-content .idb-button-secondary, .cke_editable .idb-button-primary, .cke_editable .idb-button-secondary, .styled-text .idb-button-primary, .styled-text .idb-button-secondary {
  font-weight: var(--fw-semibold);
}

:host .idb-button-primary, :host .idb-button-secondary, .ck-content .idb-button-primary, .ck-content .idb-button-secondary, .cke_editable .idb-button-primary, .cke_editable .idb-button-secondary, .styled-text .idb-button-primary, .styled-text .idb-button-secondary {
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

:host .idb-button-primary, :host .idb-button-secondary, .ck-content .idb-button-primary, .ck-content .idb-button-secondary, .cke_editable .idb-button-primary, .cke_editable .idb-button-secondary, .styled-text .idb-button-primary, .styled-text .idb-button-secondary {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

:host .idb-button-primary, :host .idb-button-secondary, .ck-content .idb-button-primary, .ck-content .idb-button-secondary, .cke_editable .idb-button-primary, .cke_editable .idb-button-secondary, .styled-text .idb-button-primary, .styled-text .idb-button-secondary {
  line-height: 1.5 !important;
}

:host .idb-button-primary,
  :host .idb-button-secondary,
  .ck-content .idb-button-primary,
  .ck-content .idb-button-secondary,
  .cke_editable .idb-button-primary,
  .cke_editable .idb-button-secondary,
  .styled-text .idb-button-primary,
  .styled-text .idb-button-secondary{
    padding:0.5em 1em !important;
  }

:host .idb-button-primary, .ck-content .idb-button-primary, .cke_editable .idb-button-primary, .styled-text .idb-button-primary {
  border-style: none;
}

:host .idb-button-primary, .ck-content .idb-button-primary, .cke_editable .idb-button-primary, .styled-text .idb-button-primary {
  background-color: var(--idblab-magenta-main) !important;
}

:host .idb-button-primary, .ck-content .idb-button-primary, .cke_editable .idb-button-primary, .styled-text .idb-button-primary {
  color: var(--neutral-white) !important;
}

:host .idb-button-primary:hover, :host .idb-button-primary:focus, .ck-content .idb-button-primary:hover, .ck-content .idb-button-primary:focus, .cke_editable .idb-button-primary:hover, .cke_editable .idb-button-primary:focus, .styled-text .idb-button-primary:hover, .styled-text .idb-button-primary:focus {
  background-color: var(--idblab-magenta-darken-2) !important;
}

:host .idb-button-primary:hover, :host .idb-button-primary:focus, .ck-content .idb-button-primary:hover, .ck-content .idb-button-primary:focus, .cke_editable .idb-button-primary:hover, .cke_editable .idb-button-primary:focus, .styled-text .idb-button-primary:hover, .styled-text .idb-button-primary:focus {
  color: var(--neutral-white) !important;
}

:host .idb-button-secondary, .ck-content .idb-button-secondary, .cke_editable .idb-button-secondary, .styled-text .idb-button-secondary {
  background-color: var(--neutral-white) !important;
}

:host .idb-button-secondary, .ck-content .idb-button-secondary, .cke_editable .idb-button-secondary, .styled-text .idb-button-secondary {
  color: var(--idblab-magenta-main) !important;
}

:host .idb-button-secondary, .ck-content .idb-button-secondary, .cke_editable .idb-button-secondary, .styled-text .idb-button-secondary{
    border:1px solid var(--idblab-magenta-main);
  }

:host .idb-button-secondary:hover, :host .idb-button-secondary:focus, .ck-content .idb-button-secondary:hover, .ck-content .idb-button-secondary:focus, .cke_editable .idb-button-secondary:hover, .cke_editable .idb-button-secondary:focus, .styled-text .idb-button-secondary:hover, .styled-text .idb-button-secondary:focus {
  background-color: var(--idblab-magenta-main) !important;
}

:host .idb-button-secondary:hover, :host .idb-button-secondary:focus, .ck-content .idb-button-secondary:hover, .ck-content .idb-button-secondary:focus, .cke_editable .idb-button-secondary:hover, .cke_editable .idb-button-secondary:focus, .styled-text .idb-button-secondary:hover, .styled-text .idb-button-secondary:focus {
  color: var(--neutral-white) !important;
}

:host .facet-heading, .ck-content .facet-heading, .cke_editable .facet-heading, .styled-text .facet-heading {
  margin-bottom: 0px;
}

:host .facet-heading, .ck-content .facet-heading, .cke_editable .facet-heading, .styled-text .facet-heading {
  display: block;
}

:host .facet-heading, .ck-content .facet-heading, .cke_editable .facet-heading, .styled-text .facet-heading {
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
}

:host .facet-heading, .ck-content .facet-heading, .cke_editable .facet-heading, .styled-text .facet-heading {
  font-weight: var(--fw-bold);
}

:host .facet-heading, .ck-content .facet-heading, .cke_editable .facet-heading, .styled-text .facet-heading {
  color: var(--idblab-magenta-main);
}

:host([text-xl]) p {
  font-size: var(--fs-2xl);
  line-height: var(--lh-2xl);
}

:host([ellipsis-3]){
  display:-webkit-box;
  -webkit-line-clamp:3;
  -webkit-box-orient:vertical;
  overflow:hidden;
  word-break:break-word;
}
`;